import { Tooltip, Tag } from 'antd';

import styles from './OutputFieldTag.module.scss';

type OutputFieldTagProps = {
  text: string;
};

const OutputFieldTag = ({ text }: OutputFieldTagProps) => {
  return (
    <Tooltip title={text}>
      <Tag color="blue" className={styles.tag}>
        {text}
      </Tag>
    </Tooltip>
  );
};

export default OutputFieldTag;
